import React from 'react';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';
import './SidebarUserbox.css';
import { getTickerLogo } from 'components/watchlist/WatchlistHelpers';
import Hidden from '@material-ui/core/Hidden';
import AddRemoveWatchlist from 'components/shared/addRemoveWatchlist/AddRemoveWatchlist';
import AvatarRenderer from 'layout-components/SidebarUserbox/AvatarRenderer';
import { Typography, styled } from '@material-ui/core';

const SidebarUserbox = () => {
  const selectedItem = useSelector(state => state.Watchlist.selectedItem);

  return (
    <>
      <StyledBox>
        <AvatarRenderer
          src={getTickerLogo(selectedItem)}
          style={{ width: '54px', height: '54px', margin: '0 auto 0.5rem' }}
        />
        <Box>
          <Box display="flex" justifyContent="center" alignItems="center">
            {selectedItem.ticker && selectedItem.companyId ? <AddRemoveWatchlist /> : null}
            <b>{selectedItem.ticker}</b>
          </Box>
          <StyledTypography color="textSecondary">{selectedItem.companyName}</StyledTypography>
          <Hidden smDown>
            <b>Sector</b>
            <StyledTypography color="textSecondary">{selectedItem.sector}</StyledTypography>
            <b>Industry</b>
            <StyledTypography color="textSecondary">{selectedItem.industry}</StyledTypography>
          </Hidden>
        </Box>
      </StyledBox>
    </>
  );
};

export default SidebarUserbox;

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#f4f5fd',
  [theme.breakpoints.down('sm')]: { backgroundColor: 'white' },
  textAlign: 'center',
  padding: '1rem',
  '& .MuiAvatar-img': { objectFit: 'contain' },
  '& .MuiAvatar-root': { borderRadius: 1 },
}));
const StyledTypography = styled(Typography)({ whiteSpace: 'initial', marginBottom: '0.5rem', lineHeight: 1.43 });
